'use strict';

var React = require('react');

/* React hook. Exports uniform event handlers for text inputs */
var useEventHandlers = function useEventHandlers(_ref) {
  var _ref$onFocus = _ref.onFocus,
    onFocus = _ref$onFocus === void 0 ? function () {} : _ref$onFocus,
    _ref$onBlur = _ref.onBlur,
    onBlur = _ref$onBlur === void 0 ? function () {} : _ref$onBlur,
    _ref$onKeyDown = _ref.onKeyDown,
    onKeyDown = _ref$onKeyDown === void 0 ? function () {} : _ref$onKeyDown,
    _ref$onKeyUp = _ref.onKeyUp,
    onKeyUp = _ref$onKeyUp === void 0 ? function () {} : _ref$onKeyUp;
  var handleFocus = React.useCallback(function (event) {
    onFocus(event);
  }, [onFocus]);
  var handleBlur = React.useCallback(function (event) {
    onBlur(event);
  }, [onBlur]);
  var handleKeyDown = React.useCallback(function (event) {
    onKeyDown(event);
  }, [onKeyDown]);
  var handleKeyUp = React.useCallback(function (event) {
    onKeyUp(event);
  }, [onKeyUp]);
  return {
    handleFocus: handleFocus,
    handleBlur: handleBlur,
    handleKeyDown: handleKeyDown,
    handleKeyUp: handleKeyUp
  };
};

exports.useEventHandlers = useEventHandlers;
//# sourceMappingURL=useEventHandlers-fe0dbdf6.js.map
